export enum CreateDraftReturnErrorCode {
  Unauthorized = "Unauthorized",
  Throttled = "Throttled",
  OrderNotFound = "OrderNotFound",
  RegistrationHasLinkedOrder = "RegistrationHasLinkedOrder",
  UnexpectedError = "UnexpectedError",
  TeamUnauthorized = "TeamUnauthorized",
}

export const friendlyCreateDraftReturnErrorMessages: Record<
  CreateDraftReturnErrorCode,
  string
> = {
  [CreateDraftReturnErrorCode.Unauthorized]:
    "You don't have permission to view this order.",
  [CreateDraftReturnErrorCode.Throttled]:
    "The server was too busy to process your request. Please try again in a few moments.",
  [CreateDraftReturnErrorCode.OrderNotFound]:
    "The order you're trying to view doesn't exist, or you don't have permission to view it.",
  [CreateDraftReturnErrorCode.UnexpectedError]:
    "An unexpected error occurred. Please try again later, or contact support if the problem persists.",
  [CreateDraftReturnErrorCode.TeamUnauthorized]:
    "There is a temporary issue submitting returns with this store. Please try again later, or contact support if the problem persists.",
  [CreateDraftReturnErrorCode.RegistrationHasLinkedOrder]:
    "This warranty registration is linked to an order. Please submit a claim on the order instead.",
};
